import React from 'react';

export function India(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V114H0V0Z" fill="#FF9933"/>
      <path d="M0 114H513V228H0V114Z" fill="white"/>
      <path d="M0 228H513V342H0V228Z" fill="#138808"/>
      <circle cx="256.5" cy="171" r="35" fill="none" stroke="#000080" strokeWidth="5"/>
      <circle cx="256.5" cy="171" r="5" fill="#000080"/>
      {[0,15,30,45,60,75,90,105,120,135,150,165,180,195,210,225,240,255,270,285,300,315,330,345].map((angle, i) => {
        const rad = (angle * Math.PI) / 180;
        return <line key={i} x1={256.5 + 5 * Math.cos(rad)} y1={171 + 5 * Math.sin(rad)} x2={256.5 + 35 * Math.cos(rad)} y2={171 + 35 * Math.sin(rad)} stroke="#000080" strokeWidth="1.5"/>;
      })}
    </svg>
  );
}
